import { render, staticRenderFns } from "./draw-rules.vue?vue&type=template&id=67868b72&scoped=true&"
import script from "./draw-rules.vue?vue&type=script&lang=js&"
export * from "./draw-rules.vue?vue&type=script&lang=js&"
import style0 from "./draw-rules.vue?vue&type=style&index=0&id=67868b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67868b72",
  null
  
)

export default component.exports